<script>
  import Strapi from "strapi-sdk-javascript";
  //import {link, navigate} from 'svelte-routing';
  import { link, navigate } from "svelte-routing";
  import {
    Card,
    CardBody,
    CardFooter,
    CardHeader,
    CardSubtitle,
    CardText,
    CardTitle,
    Form,
    Button,
    FormGroup,
    Input,
    Label,
  } from "sveltestrap";
  import PlainLayout from "../layouts/Plain.svelte";
  /* import { Router, Route, navLink } from "swheel"; */
  import { strapi_api } from "../utils/config";
  const strapi = new Strapi(strapi_api);
  //import { goto } from "@sapper/app";

  let username;
  let password;
  var loginStatus = true;

  async function handleSubmit() {
    let result;
    try {
      result = await strapi.login(username, password);
      //console.log(result);
      localStorage.setItem("token", result.jwt);
      localStorage.setItem("email", result.user.email);
      localStorage.setItem("strapiApi", strapi_api);
      localStorage.setItem("username", result.user.username);
      localStorage.setItem("userid", result.user.id);
      localStorage.setItem("roleType", result.user.role.type);
      navigate("/books", { replace: true });
    } catch (error) {
      document.getElementById("alert").style.display = "block";
      setTimeout(() => {
        document.getElementById("alert").style.display = "none";
      }, 3000);
      console.log("Wrong user name or password");
    }
  }
  const handleKeyup = () => {
    if (event.code == "Enter") {
      handleSubmit();
      return false;
    }
  };
  let showPasssword = false;
</script>

<PlainLayout>
  <Card class="col-6 login-card">
    <CardHeader class="text-center">
      <img
        src="./images/logo.svg"
        class=""
        width="70px"
        height="70px"
        alt="Logo"
      />
      <CardTitle class="text-center card-title"
        >Log in to onelern content review tool</CardTitle
      >
    </CardHeader>
    <CardBody>
      <Form class="form-holder card-holder m-auto">
        <FormGroup>
          <Label class="lable-color mt-2">Email</Label>
          <Input
            type="text"
            id="username"
            name="username"
            on:keyup={handleKeyup}
            bind:value={username}
          />
        </FormGroup>
        <FormGroup>
          <Label class="lable-color mt-32">Password</Label>
          <Input
            type={showPasssword ? "text" : "password"}
            id="password"
            on:keyup={handleKeyup}
            name="password"
            bind:value={password}
          />
          <div
            class="eye-btn"
            on:click={() => (showPasssword = !showPasssword)}
          >
            <span class="material-icons"
              >{showPasssword ? "visibility" : "visibility_off"}</span
            >
          </div>
        </FormGroup>
      </Form>
    </CardBody>
    <div class="alert alert-danger in center" id="alert">
      <strong>Email or password invalid</strong>
    </div>

    <CardFooter class="text-center">
      <!-- <div class="error-text">User Name or Password invalid</div> -->
      <Button
        class="btn btn-primary btn-login"
        type="submit"
        on:click={handleSubmit}>Login</Button
      >
    </CardFooter>
  </Card>
</PlainLayout>

<style>
  
  .eye-btn {
    position: absolute;
    right: 10px;
    font-size: 20px;
    padding: 0;
    border: none;
    background: none;
    outline: none;
    top: 50%;
    transform: translateY(-0%);
    user-select: none;
  }

  .alert {
    display: none;
    text-align: center;
    color: #c4183c;
    background: transparent;
  }
  .eye-btn {
    cursor: pointer;
  }
</style>
